// AsyncComponent.tsx
import * as React from 'react'

interface AsyncComponentState {
  Component: null | JSX.Element
};
type IAsyncComponent = (importComponent: () => Promise<{ default: React.ComponentType<any> }>) => React.ComponentClass

const asyncComponent: IAsyncComponent = (importComponent) => {
  class AsyncFunc extends React.PureComponent<any, AsyncComponentState> {
    mounted: boolean = false
    constructor (props: any) {
      super(props)

      this.state = {
        Component: null
      }
    }

    componentWillUnmount (): void {
      this.mounted = false
    }

    async componentDidMount (): Promise<void> {
      this.mounted = true
      const { default: Component } = await importComponent()
      if (this.mounted) {
        this.setState({
          Component: <Component {...this.props} />
        })
      }
    }

    render (): JSX.Element {
      const Component = this.state.Component
      return (Component != null) ? Component : <div>....Загрузка</div>
    }
  }
  return AsyncFunc
}
export default asyncComponent
